import get from 'lodash/get'
import { ANALYTICS_EVENTS } from '../utils'

export const getFacilityProductsHandler = ({ events }) => {
  const {
    PRODUCT_VIEWED,
    PRODUCT_ADDED_TO_CART,
    CHECKOUT_STARTED,
    ORDER_COMPLETED,
    ORDER_PAYMENT_FAILED,
    PRODUCTS_SEARCHED,
    ORDERING_SESSION_STARTED,
    ORDERING_SESSION_RESUMED,
    ORDER_DRAFT_SAVED,
    ORDER_REVIEW_VISITED,
    ORDER_UNAVAILABLE_ITEMS_REMOVED,
    ORDER_SUBMISSION_FAILED,
    ORDER_BUDGET_SET
  } = ANALYTICS_EVENTS

  return {
    viewed: (product) => {
      events.track(PRODUCT_VIEWED, {
        product_id: product._id,
        product_name: product.name,
        price: product.latestPrice,
        stock_level: product.amountInStock,
        brand: get(product, 'additionalData.manufacturer'),
        category: product.productType
      })
    },

    addedToCart: ({ product, quantity }) => {
      events.track(PRODUCT_ADDED_TO_CART, {
        product_id: product._id,
        product_name: product.name,
        price: product.latestPrice,
        stock_level: product.amountInStock,
        brand: get(product, 'additionalData.manufacturer'),
        category: product.productType,
        quantity: quantity
      })
    },

    checkoutStarted: (data) => {
      const {orderValue, productCount, totalQuantity} = data
      events.track(CHECKOUT_STARTED, {
        order_value: orderValue,
        total_products: productCount,
        total_quantity: totalQuantity
      })
    },

    orderCompleted: (data) => {
      const {orderId, orderValue, productCount, totalQuantity} = data
      events.track(ORDER_COMPLETED, {
        order_value: orderValue,
        total_products: productCount,
        total_quantity: totalQuantity,
        order_id: orderId
      })
    },

    productsSearched: (data) => {
      const {
        filterTerm,
        selectedFilters,
        resultsCount
      } = data
      const filters = Object.values(selectedFilters).reduce((acc, filter) => {
        acc = acc.concat(filter.selected)
        return acc
      }, [])

      events.track(PRODUCTS_SEARCHED, {
        search_term: filterTerm,
        results_count: resultsCount,
        filters_used: filters
      })
    },

    orderingSessionStarted: (data) => {
      const { programId, locationId } = data
      events.track(ORDERING_SESSION_STARTED, {
        program_id: programId,
        location_id: locationId
      })
    },

    orderingSessionResumed: (data) => {
      const { orderId, updatedAt } = data
      events.track(ORDERING_SESSION_RESUMED, {
        order_id: orderId,
        last_updated_at: updatedAt
      })
    },

    orderDraftSaved: (data) => {
      const { orderId, productCount, orderValue } = data
      events.track(ORDER_DRAFT_SAVED, {
        order_value: orderValue,
        total_products: productCount,
        order_id: orderId
      })
    },

    orderReviewVisited: (data) => {
      const { orderId, productCount, orderValue } = data
      events.track(ORDER_REVIEW_VISITED, {
        order_value: orderValue,
        total_products: productCount,
        order_id: orderId
      })
    },

    unavailableProductsRemoved: (data) => {
      const { orderId, removedProductIds, removedProductCount } = data
      events.track(ORDER_UNAVAILABLE_ITEMS_REMOVED, {
        removed_product_ids: removedProductIds,
        removed_count: removedProductCount,
        order_id: orderId
      })
    },

    orderSubmissionFailed: (data) => {
      const { orderId, error } = data
      events.track(ORDER_SUBMISSION_FAILED, {
        order_id: orderId,
        error: error
      })
    },

    budgetSet: (data) => {
      const { orderId, budget, productsAdded } = data
      events.track(ORDER_BUDGET_SET, {
        budget_amount: budget,
        order_id: orderId,
        products_added: productsAdded
      })
    },

    // TODO: Find where to hook it to get expected results
    paymentFailed: ({orderValue, error}) => {
      events.track(ORDER_PAYMENT_FAILED, {
        order_value: orderValue,
        error: error
      })
    }
  }
}
